<div
  class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between"
>
  <h5 class="mb-0">Profissionais Inativos</h5>
  <ol class="breadcrumb mb-0 ps-0">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item">
      <a routerLink="/professionals">Profissionais</a>
    </li>
    <li class="breadcrumb-item fw-semibold">Inativos</li>
  </ol>
</div>

<mat-card class="mb-25 tagus-card">
  <mat-card-content>
    <div class="d-flex">
      <div class="tagus-form-group w-100">
        <mat-form-field appearance="fill">
          <i class="ri-search-line"></i>
          <mat-label>Filtrar por nome</mat-label>
          <input matInput (keyup)="applyFilter($event)" #input />
        </mat-form-field>
      </div>
      <div>
        <button mat-icon-button (click)="getAll()">
          <mat-icon>update</mat-icon>
        </button>
      </div>
    </div>

    <div class="mat-elevation-z8 tagus-mat-table">
      <div *ngIf="isLoading" class="skeleton-table">
        <div class="skeleton-header">
          <div class="skeleton-cell skeleton-cell--sm"></div>
          <div class="skeleton-cell skeleton-cell--lg"></div>
          <div class="skeleton-cell skeleton-cell--md"></div>
          <div class="skeleton-cell skeleton-cell--xl"></div>
          <div class="skeleton-cell skeleton-cell--sm"></div>
          <div class="skeleton-cell skeleton-cell--md"></div>
          <div class="skeleton-cell skeleton-cell--sm"></div>
          <div class="skeleton-cell skeleton-cell--sm"></div>
        </div>
        <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5]">
          <div class="skeleton-cell skeleton-cell--avatar shimmer"></div>
          <div class="skeleton-cell skeleton-cell--lg shimmer"></div>
          <div class="skeleton-cell skeleton-cell--md shimmer"></div>
          <div class="skeleton-cell skeleton-cell--xl shimmer"></div>
          <div class="skeleton-cell skeleton-cell--sm shimmer"></div>
          <div class="skeleton-cell skeleton-cell--md shimmer"></div>
          <div class="skeleton-cell skeleton-cell--sm shimmer"></div>
          <div class="skeleton-cell skeleton-cell--sm shimmer"></div>
        </div>
      </div>

      <table mat-table [dataSource]="dataSource" [class.d-none]="isLoading">
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Ação</th>
          <td mat-cell *matCellDef="let element">
            <button
              type="button"
              mat-button
              class="position-relative dot-btn p-0 bg-transparent border-none"
              [matMenuTriggerFor]="actionMenu"
            >
              <i class="ri-more-2-fill"></i>
            </button>
            <mat-menu #actionMenu="matMenu" class="dotMenu two monthMenu" xPosition="before">
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="goToUserEdit(element.id)"
              >
                <i class="ri-edit-line"></i> Visualizar/Editar
              </button>
              <button
                mat-menu-item
                type="button"
                class="bg-transparent border-none position-relative"
                (click)="reactivate(element.id)"
              >
                <i class="ri-restart-line"></i> Reativar Profissional
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <img
              [src]="getPhotoSrc(element.id)"
              (error)="$any($event.target).src='assets/img/user/user1.jpg'"
              alt="{{ element.name }}"
              class="border-radius photo-thumb"
              width="40"
              height="40"
            />
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let element" class="text-left">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="document">
          <th mat-header-cell *matHeaderCellDef>CPF</th>
          <td mat-cell *matCellDef="let element">{{ element.document }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>

        <ng-container matColumnDef="licenseNumber">
          <th mat-header-cell *matHeaderCellDef>Nº Licença</th>
          <td mat-cell *matCellDef="let element">{{ element.licenseNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="cellphone">
          <th mat-header-cell *matHeaderCellDef>Celular</th>
          <td mat-cell *matCellDef="let element">{{ element.cellphone }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status Cadastro</th>
          <td mat-cell *matCellDef="let element">{{ getNameStatus(element.status) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            Nenhum profissional inativo encontrado.
          </td>
        </tr>
      </table>
      <mat-paginator
        [length]="totalProfessionals"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)"
        showFirstLastButtons
        aria-label="Selecione a página"
      ></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
